import {useState, useEffect} from "react";
import { domain } from "config.js";

import style from "./style.module.scss";

function Item({ refNo, imagesState, data }) {
    const {itemImages, setItemImages} = imagesState;

    useEffect(()=>{
        loadPropImage();
    }, []);

    useEffect(()=>{
    }, [itemImages]);
    
    async function loadPropImage() {
        if (itemImages[refNo]?.image) return;
        fetch(domain + "/int-getFiles", { method: "POST", body: JSON.stringify({ ref: (refNo + ""), cover: true, type: "slideshow" }) }).then(response => {

            response.json().then(data => {
                setItemImages(itemImages=>{
                    var imag = data[0];
    
                    var newData = { ...itemImages };
                    var vl = imag;

                    newData[refNo] = { image: vl };

                    return newData;
                });


            });
        });
    }


    return (
        <div className={style.root}>
            <img src={itemImages[refNo]?.image} alt="property" />
            <div className={style.textContent}>
                <div>{`${data?.type || ""} in ${data?.location || ""}`}</div>
                <div>{monetize(data?.price || "")}</div>
                <div className={style.normalCase}>Breathtaking panoramic views, your own tennis court, privacy, lots of space and what a garden!</div>
                <div>{`${data?.region || ""} - ${data?.location || ""} - ${data?.bedrooms || ""} BAD - ${data?.type || ""} . ${refNo || ""}`}</div>
            </div>
        </div>
    );

    function monetize(price) {
        const formatter = Intl.NumberFormat({style:"decimal"});

        let value =  formatter.format(price);

        value = value.replace(new RegExp(",", "g"), " ");
        value = value + " €";

        return value;
    }
}

export default Item;